import {
  index,
  pgTable,
  primaryKey,
  text,
  timestamp,
  uniqueIndex,
  uuid,
  varchar,
} from "drizzle-orm/pg-core";
import { user } from "./auth";

export type AdminNotificationSeverity = "normal" | "warning" | "critical";
export type AdminNotificationAudience = "permission" | "all_admins";

export const adminNotifications = pgTable(
  "admin_notifications",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    type: varchar("type", { length: 80 }).notNull(),
    title: text("title").notNull(),
    body: text("body"),
    entityType: varchar("entity_type", { length: 50 }),
    entityId: uuid("entity_id"),
    href: text("href").notNull(),
    severity: varchar("severity", { length: 20 })
      .$type<AdminNotificationSeverity>()
      .default("normal")
      .notNull(),
    audience: varchar("audience", { length: 20 })
      .$type<AdminNotificationAudience>()
      .default("permission")
      .notNull(),
    requiredPermission: varchar("required_permission", { length: 80 }),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull(),
    expiresAt: timestamp("expires_at", { withTimezone: true }),
  },
  (t) => [
    index("admin_notifications_created").on(t.createdAt),
    index("admin_notifications_type").on(t.type, t.createdAt),
    uniqueIndex("admin_notifications_entity_unique").on(
      t.type,
      t.entityType,
      t.entityId,
    ),
  ],
);

export const adminNotificationReads = pgTable(
  "admin_notification_reads",
  {
    notificationId: uuid("notification_id")
      .notNull()
      .references(() => adminNotifications.id, { onDelete: "cascade" }),
    userId: text("user_id")
      .notNull()
      .references(() => user.id, { onDelete: "cascade" }),
    readAt: timestamp("read_at", { withTimezone: true }).notNull(),
  },
  (t) => [primaryKey({ columns: [t.notificationId, t.userId] })],
);
